import './app.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {
  Home,
  Settings,
  Inventory,
  Login,
  Logout,
  CreateAccount,
  ListingDashboard,
  ListingPage,
  LandingPage,
  AuthAction,
} from "./pages"
import SubscriptionSuccess from './pages/subscription/subscription-success';
import SubscriptionCancelled from './pages/subscription/subscription-cancelled';
import { useSigninCheck } from './hooks/use-firebase';
import { SidebarProvider } from './components/ui/sidebar';


export const App = () => {

  const { data: signInData } = useSigninCheck()

  return (
    <BrowserRouter>
      {
        signInData?.signedIn ? (
          <SidebarProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/subscription/success" element={<SubscriptionSuccess />} />
              <Route path="/subscription/cancelled" element={<SubscriptionCancelled />} />
              <Route path="/listings" element={<ListingDashboard />} />
              <Route path="/listings/:listingId" element={<ListingPage />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="/auth/action" element={<AuthAction />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </SidebarProvider>
        ) : (
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/create-account" element={<CreateAccount />} />
            <Route path="/auth/action" element={<AuthAction />} />
          </Routes>
        )
      }

    </BrowserRouter>


  );
}

function NotFound() {
  return (
    <div>
      <h1>404</h1>
      <p>Page not found.</p>
    </div>
  );
}

